<template>
  <div :class="`bg-danger rounded text-center p-2 text-white ${addClass}`">
    <div class="d-inline info-text">
      {{ $t('common.message.not-complete-contract-data') }}
    </div>
    <br><br>
    <std-button
      type="A"
      :title="$t('common.message.button.edit-data')"
      :route-link="{'name': 'profile-contract-data-edit'}"
    />
  </div>
</template>

<script>
export default {
  props: {
    addClass: {
      type: String,
      default: ''
    }
  }
}
</script>
